export class FordProtect {
  public country!: string;
  public vin!: string;
  public vinWSD!: string;
  public contractList!: ContractList[];
}

export class CoverageList {
  public coverageType!: string;
  public coverageCode!: string;
  public coverageName!: string;
  public coverageStatus!: string;
  public coverageVisits!: number;
  public coverageVisitsDone!: number;
  public coverageStartVisit!: number;
  public coverageTerm!: number;
  public coverageDistance!: number;
  public coverageStartDate!: string;
  public coverageEndDate!: string;
  public coverageDescription!: string;
}

export class ContractList {
  public contractId!: string;
  public productName!: string;
  public productStatus!: string;
  public productCode!: string;
  public contractSaleDate!: string;
  public contractStartDate!: string;
  public contractEndDate!: string;
  public contractExpiredDate!: string;
  public coverageList!: CoverageList[];
}

